import { ICellRendererParams } from "ag-grid-community";
import { useRef, useState } from "react";
import CustomModal from "./CustomModal";
import { CrossIcon, DocumentTextIcon, SpinnerIcon, UploadIcon } from "../Icons";
import { fileToBase64 } from "../../utils";
import {
  useFileUploadMutation,
  useServeFileQuery,
} from "../../store/apiSlices/common";
import { toast } from "react-toastify";
import { FilePreview } from "./TradeFlowTrackerTabs/UploadDocVault";

export default function FileCellRenderer(params: ICellRendererParams) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [fileupload, { isLoading }] = useFileUploadMutation();

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const field = params.colDef?.field;
    if (!field) return; // safe guard

    const base64String = await fileToBase64(file);
    const payload = {
      base64File: base64String,
      folder_name: "deal_tracker",
    };

    const { data } = await fileupload(payload);

    if (data.status === "success" && data.url) {
      toast.success(data.msg || "File uploaded successfully.");

      // update only the cell
      params.node.setDataValue(field, data.url);

      // optional: global save
      params.context?.handleSave?.();
    } else {
      toast.error("Something went wrong! please try again");
    }
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <span>
          {params.value ? (
            <button
              type="button"
              onClick={toggleModal}
              className="flex items-center gap-1 hover:text-custom-blue-medium hover:underline"
            >
              <DocumentTextIcon className="size-4" />
              View file
            </button>
          ) : (
            "No file selected"
          )}
        </span>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          disabled={isLoading}
          className="px-2 py-1 bg-gray-200 rounded disabled:cursor-none disabled:opacity-50"
        >
          {isLoading ? (
            <SpinnerIcon className="size-5 text-gray-200 animate-spin fill-blue-600" />
          ) : (
            <UploadIcon className="size-6" />
          )}
        </button>
      </div>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="rounded-xl p-6 max-w-5xl w-full"
      >
        <div className="mb-4 text-white">
          <button onClick={toggleModal} className="float-end hover:scale-95">
            <CrossIcon className="size-6" />
          </button>
          <h3 className="font-medium">
            File - <i>{params.colDef?.headerName}</i>
          </h3>
        </div>

        <ViewUploadedFile value={params.value} />
      </CustomModal>
    </>
  );
}

function ViewUploadedFile({ value }: { value: string }) {
  const { data: uploadedDocFile, isLoading: isLoadingDocFile } =
    useServeFileQuery(value, {
      skip: !value,
    });

  return (
    <div className="h-[80vh]">
      <FilePreview
        uploadedDocFile={uploadedDocFile}
        isLoadingDocFile={isLoadingDocFile}
      />
    </div>
  );
}
